import React from 'react';
import { NavLink } from 'react-router-dom';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import './ServicesComponent.scss';

const services = [
    {
        title: 'A2B Transfer',
        description: 'Convenient point-to-point transportation with our reliable A2B transfer service.',
        image: '/images/services/a2btransfer.jpg'
    },
    {
        title: 'Bus / Large Group Transfer',
        description: 'Perfect for corporate events, tours, or large gatherings with spacious buses.',
        image: '/images/services/bus.jpg'
    },
    {
        title: 'Private Guide',
        description: 'Explore Hungary with a knowledgeable local guide offering personalized insights.',
        image: '/images/activities/fishermans-bastion.jpg'
    },
    {
        title: 'Experiences',
        description: 'Discover the best of Hungary with our curated tours:',
        subServices: [
            'Private Tours in Budapest',
            'Private Tours in the Countryside', 
            'Danube Cruise',
            'The Ultimate Hungaroring Experience'
        ],
        image: '/images/activities/cruise-budapest.jpg'
    },
    {
        title: 'Air Cruises',
        description: 'Experience Hungary from a unique perspective with exclusive air cruise services.',
        image: '/images/services/aircruises.jpg'
    },
    {
        title: 'Hungarian Thermal Baths',
        description: 'Immerse yourself in Hungary\'s world-renowned thermal bath culture.',
        image: '/images/activities/szechenyi-bath.jpg'
    }
];

const ServicesComponent = () => {
    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3,
            slidesToSlide: 1
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2,
            slidesToSlide: 1
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            slidesToSlide: 1
        }
    };

    return (
        <div className="services-component container py-5">
            <h2 className="text-center mb-5">Our Services</h2>
            <Carousel
                responsive={responsive}
                infinite={true}
                autoPlay={true}
                autoPlaySpeed={3000}
                keyBoardControl={true}
                transitionDuration={500}
                containerClass="services-carousel"
                itemClass="services-carousel-item"
            >
                {services.map((service, index) => (
                    <div 
                        key={index} 
                        className="service-card"
                        style={{backgroundImage: `url(${service.image})`}}
                    >
                        <div className="service-card-overlay"></div>
                        <div className="service-card-content">
                            <h3>{service.title}</h3>
                            <p>{service.description}</p>
                            {service.subServices && (
                                <ul>
                                    {service.subServices.map((subService, subIndex) => (
                                        <li key={subIndex}>{subService}</li>
                                    ))}
                                </ul>
                            )}
                            {service.title === 'Experiences' && (
                                <NavLink 
                                    to="/experiences" 
                                    className="btn btn-primary mt-3"
                                >
                                    View Experiences
                                </NavLink>
                            )}
                        </div>
                    </div>
                ))}
            </Carousel>
        </div>
    );
};

export default ServicesComponent;
